<template>
<div class="page-container-content tabgroup">
  <component :is="currentView" :active="active" ref="currentComponent"></component>
</div>
</template>

<script>
import eq from 'lodash/eq';
import { mapGetters } from 'vuex';
import WTopologymapAllPerfList from '@/views/topologymap/components/perfoper/performance/components/TopologymapAllPerfList';
import WTopologymapServerPerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapServerPerfTable';
import WTopologymapNetdevicePerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapNetdevicePerfTable';
import WTopologymapInterfacePerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapInterfacePerfTable';
import WTopologymapSensorPerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapSensorPerfTable';
import WTopologymapDatabasePerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapDatabasePerfTable';
import WTopologymapE2EPerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapE2EPerfTable';
import WTopologymapVirtualPerfView from '@/views/topologymap/components/perfoper/performance/components/TopologymapVirtualPerfView';
import WTopologymapApmPerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapApmPerfTable';
import WTopologymapServicePerfTable from '@/views/topologymap/components/perfoper/performance/components/TopologymapServicePerfTable';

export default {
  name: 'WTopologymapPerformanceIndex',
  components: {
    WTopologymapAllPerfList,
    WTopologymapServerPerfTable,
    WTopologymapNetdevicePerfTable,
    WTopologymapInterfacePerfTable,
    WTopologymapSensorPerfTable,
    WTopologymapDatabasePerfTable,
    WTopologymapE2EPerfTable,
    WTopologymapVirtualPerfView,
    WTopologymapApmPerfTable,
    WTopologymapServicePerfTable,
  },
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
    perfViewType: {
      type: String,
      default: () => 'list',
    },
  },
  data() {
    return {
      currentView: WTopologymapAllPerfList,
      tabs: {
        performance: {
          name: 'performance',
          label: '성능 정보',
          active: true,
          default: true,
        },
        config: {
          name: 'config',
          label: '구성 정보',
          active: false,
        },
      },
    };
  },
  mounted() {},
  computed: mapGetters(['selectedObjDefineIds']),
  watch: {
    selectedObjDefineIds: {
      immediate: true,
      handler(selectedList) {
        this.changeView(selectedList);
      },
    },
    active() {
      this.changeView(this.selectedObjDefineIds);
    },
  },
  methods: {
    changeView(selectedList) {
      /*
        - 선택된 장비가 하나일 경우 해당 장비의 화면 출력
        - 선택된 장비가 없거나 하나 이상일 경우 공통 화면 출력
       */
      if (!this.active) {
        return;
      }

      if (selectedList.length === 1) {
        const objDefineId = selectedList[0];

        if (eq(objDefineId, 'SERVER')) {
          this.currentView = WTopologymapServerPerfTable;
        } else if (eq(objDefineId, 'NETDEVICE')) {
          this.currentView = WTopologymapNetdevicePerfTable;
        } else if (eq(objDefineId, 'NETINTERFACE')) {
          this.currentView = WTopologymapInterfacePerfTable;
        } else if (eq(objDefineId, 'FMS_SENSOR')) {
          this.currentView = WTopologymapSensorPerfTable;
        } else if (eq(objDefineId, 'DBMS')) {
          this.currentView = WTopologymapDatabasePerfTable;
        } else if (eq(objDefineId, 'E2E_SERVICE')) {
          this.currentView = WTopologymapE2EPerfTable;
        } else if (eq(objDefineId, 'VMS_OBJECT')) {
          this.currentView = WTopologymapVirtualPerfView;
        } else if (eq(objDefineId, 'WAS')) {
          this.currentView = WTopologymapApmPerfTable;
        } else if (eq(objDefineId, 'SERVICE')) {
          this.currentView = WTopologymapServicePerfTable;
        }
      } else {
        this.currentView = WTopologymapAllPerfList;
      }
    },
    close() {
      this.$store.dispatch('setObjDefineIds', []);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/performance/TopologymapPerformanceIndex.vue